import { gql } from '@apollo/client';

export const GET_FEDEX_LABEL = gql`
  query getFedexLabelUrl($transactionUUID: String!) {
    getFedexLabelUrl(transactionUUID: $transactionUUID)
  }
`;